/** The Light2D property shape PointLight2D and DirectionalLight2D share. */
/**
 * The cull window an untouched `Light2D` carries (`scene/2d/light_2d.h:50-55`).
 * One record, because the parser's fallbacks, the linter's inverted-window test
 * and the renderer's default cull key must agree: a copy that drifts leaves the
 * linter silent on the scenes the renderer culls to black.
 */
export const LIGHT_2D_RANGE_DEFAULTS = {
    itemCullMask: 1,
    zMin: -1024,
    zMax: 1024,
    layerMin: 0,
    layerMax: 0,
};
//# sourceMappingURL=types.js.map